import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Envelope, Resource, ResourceData } from './ufos-live.types';

@Injectable({ providedIn: 'root' })
export class UfosService {
  constructor(private http: HttpClient) {}

  read<K extends Resource>(resource: K, scope: { uuid?: string; wo_number?: string; load_number?: string }, cursor?: string): Observable<Envelope<ResourceData[K]>> {
    let params = new HttpParams().set('resource', resource).set('limit', '25');
    for (const [key, value] of Object.entries(scope)) if (value) params = params.set(key, value);
    if (cursor) params = params.set('cursor', cursor);
    return this.http.get<Envelope<ResourceData[K]>>('/api/roswell/live.php', { params });
  }
}
